import { gql } from '@apollo/client';

export const GET_ACTIVE_AVV = gql`
  query GetActiveAVV {
    getActiveAVV {
      id
      fileName
      generatedAt
      data {
        kundenname
        bundesland
        weisungsbefugter
      }
    }
  }
`; 